import { Role } from "./role";

export enum CurrentView {
  BR = 'br',
  LATAM = 'latam'
}

export type User = {
  id: string;
  email: string;
  role: Role;
  roleId: string;
  currentView: CurrentView;
};
